import { isItemActive } from '@/creditflowresearch/ui/common/utils/url/activeItemMatcher';

interface IItemWithLink {
  link?: string | { pathname: string, query?: Record<string, string> },
  href?: string | { pathname: string, query?: Record<string, string> },
  [key: string]: any,
}

export const applyActiveState = <T extends IItemWithLink>(
  items: T[],
  currentPath: string,
): Array<T & { isActive: boolean }> => {
  return items.map((item) => {
    const link = item.link || item.href;
    return {
      ...item,
      isActive: link ? isItemActive(link, currentPath) : false,
    };
  });
};
